// An answer can cross the turn's finalization boundary while the card's
// callback still holds the previous render's "active" state. The host knows
// whether it delivered a live steer or needs a fresh turn.
export function workQuestionAnswerMeta(response, skipped = false) {
  return {
    skipped,
    ...(response?.replyMessage ? { replyMessage: response.replyMessage } : {}),
    ...(typeof response?.requiresResume === 'boolean' ? { requiresResume: response.requiresResume } : {}),
    ...(response?.continuationQueued === true ? { continuationQueued: true, followUpQueue: response.followUpQueue || [],
      followUpQueueRevision: response.followUpQueueRevision } : {}),
  };
}

export function workQuestionContinuation(text, { isActive, requiresResume, skipped, continuationQueued } = {}) {
  if (continuationQueued || requiresResume === false || (requiresResume !== true && isActive)) return null;
  return String(text || '').trim()
    || (skipped ? 'Skip — pick a sensible default and keep going.' : null);
}
